export function codigoConversa(id: string): string | null {
  if (!/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(id)) return null;
  return BigInt('0x' + id.replace(/-/g, '')).toString(36);
}

export function conversaDoCodigo(codigo: string): string | null {
  if (!/^[a-z0-9]{1,25}$/.test(codigo)) return null;
  let valor = BigInt(0);
  for (const c of codigo) valor = valor * BigInt(36) + BigInt(parseInt(c, 36));
  const hex = valor.toString(16).padStart(32, '0');
  if (hex.length !== 32) return null;
  return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
}
